import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchClientData,
  fetchClientFilteredData,
} from "../../features/influencerSlice/influencerSlice";

import { VscGitPullRequestGoToChanges } from "react-icons/vsc";

import { toast } from "react-toastify";
import { Button, Pagination, OverlayTrigger, Tooltip } from "react-bootstrap";
import AddNewClients from "./AddNewClients";
import UpdateInfluencer from "./UpdateInfluencer";
import DetailInfluencer from "./DetailInfluencer";
import AssigntoDm from "./AssigntoDm";
import AssigntoDmTemp from "./AssigntoDmTemp";

import UpdateStatus from "./UpdateStatus";
import { format } from "date-fns";
import Select from "react-select";
import { Link, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import useDecodedToken from "../../features/utils/hooks/useDecodedToken";
import { formatDate } from "../../utils/dateUtils";
import CryptoJS from "crypto-js";
import moment from "moment";
import Filter from "../filter/Filter";
import RequestForInfluencer from "../clientInfluencer/RequestForInfluencer";
import Breadcrumbs from "./../../Breadcrumbs";
import PaginationComponent from "../../components/common/PaginationComponent";
import { getShowingRange } from "../../features/utils/paginationUtils";
import {
  fetchDmTeam,
  fetchDmTeamRoleBasedTeam,
  InfluencerBulkAssign,
} from "../../features/commonSlice/commonSlice";
import axiosInstance from "../../api/axiosInstance";
import { convertToCSV, downloadCSV } from "../../utils/csvUtils";
import { influencerCsvColumns } from "../../utils/influencerCsvColumns";

export const headerData = {
  sr_no: "SR No.",
  action: "Action",
  client_name: "Influencer Name",
  follower_subscriber:"Followers / Subscribers",
  onboard_date: "Onboard Date",
  status: "Status",
  assign_by: "Assigned By",
  inf_language: "Language",
  tmp_assign_to: "Temporary Assigned To",
  tmp_assign_date: "Temporary Assigned To Date",
  category: "Categories",
  email: "Email id",
  contact_per: "Contact Person",
  mobile: "Mobile Number",
  managed_by_dm: "Managed By DM",
  tmp_managed_by_dm: "Temporary Managed By DM",
  assigned_duration: "Temporary Assigned Duration",
  createdBy: "Created By",
};
const DEFAULT_INF_TYPE = {
  label: "Own Influencer",
  value: "1",
};
const AllInfluencer = () => {
  const dispatch = useDispatch();
  const decodeToken = useDecodedToken();
  const navigate = useNavigate();
  const location = useLocation();
  const [formData, setFormData] = useState({
    channel_name: [],
    categories: [],
    languages: [],
    budget: { min: "", max: "" },
    subscribers: { min: "", max: "" },
    views: { min: "", max: "" },
    salesteam: null,
    inf_type: DEFAULT_INF_TYPE,
    userName: null,
    follower_subscriber: null,
    filter_channel:null,
    language_filter:null,
    infnr_status: { value: "99", label: "All" }
  });
  const { clientData, status } = useSelector((state) => state.infDataList);
  const [clientsData, setClientsData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [clientsPerPage, setClientsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "" });
  const [showModal, setShowModal] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [clientRequestInf, setClientRequestInf] = useState(false);
  const [showAssignSaleModal, setAssignSaleModel] = useState(false);
  const [showAssignTempModal, setAssignTempModel] = useState(false);
  const [showStatusModal, setStatusModel] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [showFiltersDrawer, setShowFiltersDrawer] = useState(false);
  const [apiMessage, setApiMessage] = useState("");
  const [filterType, setFilterType] = useState("all");
  const [filterCount, setFilterCount] = useState("");

  const [appliedFilters, setAppliedFilters] = useState(null);
  const [isFilterApplied, setIsFilterApplied] = useState(false);

  const [isInitialLoadDone, setIsInitialLoadDone] = useState(false);

  const [selectedRows, setSelectedRows] = useState([]);
  const [salesList, setSalesList] = useState([]);

  const { dmTeamDataRoleBased, status: commonStatus } = useSelector(
    (state) => state.influencer,
  );

  const [errorData, setErrorData] = useState([]);
  const [loginError, setLoginError] = useState("");
  const [isDownloading, setIsDownloading] = useState(false);

  useEffect(() => {
    dispatch(fetchDmTeamRoleBasedTeam());
  }, [dispatch]);

  useEffect(() => {
    setSalesList(dmTeamDataRoleBased?.data || []);
  }, [dmTeamDataRoleBased]);

  useEffect(() => {
    
    if (status === "succeeded") {
      setClientsData(clientData?.data || []);
      if (clientData?.status === false) {
        setApiMessage(clientData?.message || "Something went wrong");
      } else {
        setApiMessage("");
      }
    }
  }, [status, clientData, showStatusModal]);

   


  const sortTable = (key) => {
    let direction = "ascending";
    if (sortConfig.key === key && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key, direction });
  };

  

  const handleDetailClient = (rowData) => {
    setSelectedData(rowData);
    const encryptedId = CryptoJS.AES.encrypt(
      rowData.id.toString(),
      "your_secret_key",
    ).toString();
    navigate(`/influencer-details/${rowData?.id}`, { state: rowData });
  };


  const handleAssigntosaleClient = (rowData) => {

    setAssignSaleModel(true);
    setSelectedData(rowData);
  };
  const handleAssigntodmtemp = (rowData) => {
    setAssignTempModel(true);
    setSelectedData(rowData);
  };

  const canAssignInfluencerToDm = (s) => [0, 1, 3, 4].includes(s);
  const isTempDmAssignStatus = (s) => s === 5;
  const handleChangeStatus = (rowData) => {
    setStatusModel(true);
    setSelectedData(rowData);
  };

  const handleClientsPerPageChange = (selectedOption) => {
  const limit = selectedOption.value;

  setClientsPerPage(limit);

  setCurrentPage(1);

  const payload = {
    ...(appliedFilters || {}),
    page: 1,
    limit: limit === 2000 ? "All" : limit,
  };

  getInfluencerList(payload);
};

  const perPageOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
    { value: 2000, label: "All" }, // Add 'All' option
  ];

  const handleEditDetailClient = (rowData) => {
    setSelectedData(rowData);
    const encryptedId = CryptoJS.AES.encrypt(
      rowData.id.toString(),
      "your_secret_key",
    ).toString();
    navigate(`/influencer-update-details/${rowData?.id}`, { state: rowData });
  };

  const totalPages = clientData?.pagination?.totalPages || 1;
  const totalItems = clientData?.pagination?.totalItems || 0;

  const { start, end } = getShowingRange(
    currentPage,
    clientsPerPage,
    totalItems,
  );

  const openFilterDrawer = (type) => {
    setFilterType(type);
    setShowFiltersDrawer(true);
  };

  const updateFilterCount = () => {
    const saved = localStorage.getItem("influencer_filters");

    if (!saved) {
      setFilterCount(0);
      return;
    }

    try {
      const parsed = JSON.parse(saved);

      let count = 0;

      // ✅ Generic function to count only valid selected filters
      const countFilter = (filter) => {
        if (!filter) return 0;

        // Multi Select
        if (Array.isArray(filter)) {
          return filter.filter(
            (item) =>
              item &&
              item.value !== null &&
              item.value !== "" &&
              item.value !== undefined,
          ).length;
        }

        // Single Select
        return filter.value !== null &&
          filter.value !== "" &&
          filter.value !== undefined
          ? 1
          : 0;
      };

      // ✅ Count all filters
      count += countFilter(parsed?.inf_type);
      count += countFilter(parsed?.user_id);
      count += countFilter(parsed?.follower_subscriber);
      count += countFilter(parsed?.filter_channel)
      count += countFilter(parsed?.language_filter)
      count += countFilter(parsed?.status_id)
      setFilterCount(count);
    } catch (err) {
      console.error(err);
      setFilterCount(0);
    }
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = (clientsData  || []).map((item) => item.id);
      setSelectedRows(allIds);
    } else {
      setSelectedRows([]);
    }
  };
  const handleRowSelect = (id) => {
    setSelectedRows((prev = []) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id],
    );
  };
  const handleSelectChange = (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleBulkAssign = () => {
    if (!formData.salesteam) {
      alert("Please select DM");
      return;
    }

    if (!selectedRows.length) {
      alert("Please select at least one row");
      return;
    }
    try {
      const payload = {
        influencer_id: selectedRows,
        assigned_to: formData.salesteam, // ✅ FIXED
      };

      dispatch(InfluencerBulkAssign(payload))
        .unwrap()
        .then((result) => {
          if (result.status) {
            toast.success(result.message, {
              onClose: () => {
                setShowModal(false);
              },
            });
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          } else {
            setLoginError(result.message);
            setErrorData(result.form_err);
          }
        })
        .catch((err) => {
          setLoginError(err.message);
          setErrorData(err.form_err || []);
          toast.error(err.message);
        });
    } catch (error) {
      console.error("An error occurred:", error);
    }
  };

  useEffect(() => {
  if (!isInitialLoadDone) return;

  let payload = {
    status_id: formData?.infnr_status?.value || "99",
    page: currentPage,
    limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
    inf_type: null,
    user_id: null,
    follower_subscriber: null,
    filter_channel: null,
    language_filter: null,
  };

  // Apply filters if selected
  if (isFilterApplied && appliedFilters) {
    payload = {
      ...appliedFilters,
      page: currentPage,
      limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
    };
  }

  dispatch(fetchClientData(payload));
}, [
  dispatch,
  currentPage,
  clientsPerPage,
  appliedFilters,
  isFilterApplied,
  isInitialLoadDone,
]);

const getInfluencerList = (customPayload = {}) => {
  const payload = {
    status_id: formData?.infnr_status?.value || "99",
    page: currentPage,
    limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
    inf_type: null,
    user_id: null,
    follower_subscriber: null,
    filter_channel: null,
    language_filter: null,
    ...customPayload,
  };


  dispatch(fetchClientData(payload));
};

  useEffect(() => {
  const savedFilters = localStorage.getItem("influencer_filters");

  try {
    if (savedFilters) {
      const parsed = JSON.parse(savedFilters);

      setFormData((prev) => ({
        ...prev,
        inf_type: parsed?.inf_type || null,
        userName: parsed?.user_id || null,
        follower_subscriber: parsed?.follower_subscriber || null,
        filter_channel: parsed?.filter_channel || null,
        language_filter: parsed?.language_filter || null,
        infnr_status:
          parsed?.status_id || { value: "99", label: "All" },
      }));

      const payload = {
        status_id: parsed?.status_id?.value || "99",
        page: 1,
        limit: clientsPerPage === 2000 ? "All" : clientsPerPage,

        inf_type: Array.isArray(parsed?.inf_type)
          ? parsed.inf_type.map((i) => i.value)
          : parsed?.inf_type?.value || null,

        user_id: Array.isArray(parsed?.user_id)
          ? parsed.user_id.map((i) => i.value)
          : parsed?.user_id?.value || null,

        follower_subscriber:
          parsed?.follower_subscriber?.value || null,

        filter_channel: parsed?.filter_channel?.value || null,

        language_filter:
          parsed?.language_filter?.value || null,
      };

      setAppliedFilters(payload);

      // ✅ API CALL ONLY ONE TIME
      getInfluencerList(payload);

      updateFilterCount();
    } else {
      // ✅ DEFAULT API CALL ONLY ONE TIME
      getInfluencerList({
        status_id: "99",
        page: 1,
      });
    }
    setIsInitialLoadDone(true);
  } catch (error) {
    console.error("Invalid localStorage filter data", error);

    getInfluencerList({
      status_id: "99",
      page: 1,
    });
    setIsInitialLoadDone(true);
  }
}, []);

  const handleFilter = () => {
    
    let infTypeValue = null;

    if (Array.isArray(formData?.inf_type)) {
      infTypeValue = formData.inf_type.map((i) => Number(i.value));
    } else if (formData?.inf_type?.value) {
      infTypeValue = Number(formData.inf_type.value);
    }

    // ✅ user_id value
    let userIdValue = null;

    if (formData?.userName?.value) {
      userIdValue = Number(formData.userName.value);
    }
    let filtersChannel = null;
    if(formData?.filter_channel?.value){
      filtersChannel = formData?.filter_channel?.value
    }
        const followSubscriberId = formData?.follower_subscriber?.value || "";
    let filtersLanguage = null;
    if(formData?.language_filter?.value){
      filtersLanguage = formData?.language_filter?.value
    }
    let filtersInfnrStatus = String(formData?.infnr_status?.value) || "99"
    const payload = {
      status_id: filtersInfnrStatus || "99",
      page: 1,
      limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
      inf_type: infTypeValue || null,
      user_id: userIdValue || null,
      follower_subscriber: followSubscriberId,
      filter_channel: filtersChannel,
      language_filter:filtersLanguage,

    };
    
    const filterUIData = {
      inf_type: formData?.inf_type || null,
      user_id: formData?.userName || null,
      follower_subscriber: formData?.follower_subscriber,
      filterType, // optional (good for restoring tab)
      filter_channel: formData?.filter_channel,
      language_filter: formData?.language_filter,
      status_id: formData?.infnr_status,
    };

    setAppliedFilters(payload);
    setIsFilterApplied(true);
    setCurrentPage(1);
getInfluencerList(payload);
    setShowFiltersDrawer(false);

    localStorage.setItem("influencer_filters", JSON.stringify(filterUIData));

    updateFilterCount();
  };

  const handleReset = () => {
    setFormData({
      inf_type: DEFAULT_INF_TYPE,
      userName: null,
      follower_subscriber: null,
      filter_channel: null,
      language_filter: null,
      infnr_status: { value: "99", label: "All" },
    });
    localStorage.removeItem("influencer_filters");

    setAppliedFilters(null);
    setIsFilterApplied(false);
    setCurrentPage(1);
    setShowFiltersDrawer(false);


    setFilterCount(0); // ✅ MUST
  };

const handlePageChange = (page) => {
  setCurrentPage(page);

  const payload = {
    ...(appliedFilters || {}),
    page,
    limit: clientsPerPage === 2000 ? "All" : clientsPerPage,
  };

  getInfluencerList(payload);
};


  const getExportPayload = () => {
    if (isFilterApplied && appliedFilters) {
      return {
        ...appliedFilters,
        page: 1,
        limit: "All",
      };
    }
    return {
      status_id: "99",
      page: 1,
      limit: "All",
      inf_type: null,
      user_id: null,
      follower_subscriber: null,
      filter_channel: null,
      language_filter: null,
      
    };
  };
  

  const handleDownloadCSV = async () => {
  try {
    setIsDownloading(true);

    const response = await axiosInstance.post(
      "/dm/influencer_list_export",
      getExportPayload()
    );

    if (typeof response?.data === "object" && response?.data?.status === false) {
      toast.error(response?.data?.message || "You are not authorized");
      return;
    }

    const csvData = response?.data;

    if (!csvData || csvData.length === 0) {
      toast.info("No data available");
      return;
    }

    // ✅ Create Blob
    const blob = new Blob([csvData], {
      type: "text/csv;charset=utf-8;",
    });

    // ✅ Create URL
    const url = window.URL.createObjectURL(blob);

    // ✅ Create Download Link
    const link = document.createElement("a");

    link.href = url;

    // ✅ File Name
    const fileName = `influencers_${
      new Date().toISOString().split("T")[0]
    }.csv`;

    link.setAttribute("download", fileName);

    document.body.appendChild(link);

    // ✅ Download File
    link.click();

    // ✅ Cleanup
    document.body.removeChild(link);

    window.URL.revokeObjectURL(url);

    toast.success("CSV downloaded successfully");
  } catch (error) {
    console.error("CSV DOWNLOAD ERROR =>", error);

    toast.error(
      error?.response?.data?.message ||
        "CSV download failed"
    );
  } finally {
    setIsDownloading(false);
  }
};


const getFollowerSubscriberCount = (row) => {
  const channelName = row?.channel_name?.toLowerCase();
  const channelData = row?.channel_data || {};

  switch (channelName) {
    case "instagram":
      return channelData?.instagram?.followers || 0;

    case "facebook":
      return channelData?.facebook?.subscriber || 0;

    case "youtube":
    case "youtube_channel":
    case "youtubechannel":
    case "youtube_channel_name":
    case "youtubechannelname":
    case "youtube":
    case "youtube":
      return (
        channelData?.youTube?.subscriber ||
        channelData?.youTube?.followers ||
        0
      );

    default:
      return 0;
  }
};

const formatCount = (count) => {
  if (!count) return "-";

  if (count >= 10000000) {
    return `${(count / 10000000).toFixed(2)} Cr`;
  }

  if (count >= 100000) {
    return `${(count / 100000).toFixed(2)} L`;
  }

  if (count >= 1000) {
    return `${(count / 1000).toFixed(1)} K`;
  }

  return count;
};



  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 className="mb-sm-0">All Influencer</h4>

            <div className="page-title-right">
              <Breadcrumbs />
            </div>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-lg-12">
          <div className="card" id="leadsList">
            <div className="card-header border-0">
              <div className="row g-4 align-items-center">
                <div className="col-sm-1">
                  <label className="small">Select Records</label>
                  <Select
                    className="basic-single small"
                    classNamePrefix="select"
                    name="perPage"
                    options={perPageOptions}
                    defaultValue={perPageOptions[0]}
                    onChange={handleClientsPerPageChange}
                  />
                </div>
                <div className="col-sm-auto ms-auto">
                  <div className="hstack gap-2">
                    {(decodeToken?.UsrRoleId === 1 ||
                      decodeToken?.UsrRoleId === 3 ||
                      decodeToken?.UsrRoleId === 10 ||
                      decodeToken?.UsrRoleId === 11 ||
                      decodeToken?.UsrRoleId === 16) && (
                        <>
                          <Select
                            name="salesteam"
                            options={salesList || []}
                            classNamePrefix="select"
                            onChange={(selected) =>
                              handleSelectChange("salesteam", selected)
                            }
                            value={formData.salesteam || null}
                          />
                          <Button
                            className="btn btn-success add-btn"
                            onClick={() => handleBulkAssign()}
                            disabled={
                              selectedRows.length === 0 || !formData?.salesteam
                            }
                          >
                            <i className="ri-user-shared-fill align-bottom me-1"></i>
                            Assign
                          </Button>
                        </>
                      )}
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="download-csv-tooltip">
                          Download CSV
                        </Tooltip>
                      }
                    >
                      <Button
                        className="btn btn-primary"
                        onClick={handleDownloadCSV}
                        disabled={isDownloading}
                      >
                        <i className="ri-download-2-line align-bottom me-1"></i>
                        {isDownloading ? "Downloading..." : "Download CSV"}
                      </Button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="inactive-filter-tooltip">
                          Add Filter
                        </Tooltip>
                      }
                    >
                      <button
                        type="button"
                        className="btn btn-info"
                        onClick={() => openFilterDrawer("all")}
                      >
                        <i className="ri-filter-line align-bottom me-1"></i>{" "}
                        {filterCount > 0 && (
                          <span
                            className="position-absolute top-0 start-98 translate-middle badge rounded-pill bg-danger"
                            style={{
                              fontSize: "10px",
                              marginTop: "8px",
                              marginLeft: "7px",
                            }}
                          >
                            {filterCount}
                          </span>
                        )}
                      </button>
                    </OverlayTrigger>
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="inactive-clear-filter-tooltip">
                          Clear Filter
                        </Tooltip>
                      }
                    >
                      <button
                        type="button"
                        className="btn btn-danger"
                        onClick={handleReset}
                      >
                        <i className="ri-filter-off-line align-bottom me-1"></i>{" "}
                      </button>
                    </OverlayTrigger>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive">
                <table
                  id="example"
                  className="table table-bordered nowrap table-striped align-middle"
                  style={{ width: "100%" }}
                >
                  <thead>
                    <tr>
                      {(decodeToken?.UsrRoleId === 1 ||
                        decodeToken?.UsrRoleId === 3 ||
                        decodeToken?.UsrRoleId === 10 ||
                        decodeToken?.UsrRoleId === 11 ||
                        decodeToken?.UsrRoleId === 16) && (
                          <th>
                            <input
                              type="checkbox"
                              onChange={handleSelectAll}
                              checked={
                                selectedRows.length > 0
                              }
                            />
                          </th>
                        )}
                      <th>{headerData.sr_no}</th>
                      <th>{headerData.action}</th>
                      <th onClick={() => sortTable("name")}>
                        {headerData.client_name}
                      </th>
                      <th>{headerData.follower_subscriber}</th>
                      <th>{headerData.onboard_date}</th>
                      <th>{headerData.status}</th>
                      <th>{headerData.email}</th>
                      <th>{headerData.contact_per}</th>
                      <th>{headerData.mobile}</th>
                      <th>{headerData.assign_by}</th>
                      <th>{headerData.managed_by_dm}</th>
                      <th>{headerData.inf_language}</th>
                     {/*  <th>{headerData.tmp_managed_by_dm}</th>
                      <th>{headerData.assigned_duration}</th> */}
                      <th>{headerData.createdBy}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {apiMessage ? (
                      <tr>
                        <td colSpan="12" className="text-center text-danger">
                          {apiMessage}
                        </td>
                      </tr>
                    ) : clientsData.length > 0 ? (
                      clientsData.map((dataActive, index) => {
                        const canManageRow =
                          dataActive.assigned_to_id === decodeToken?.UsrId ||
                          dataActive.tmp_assigned_to_id ===
                          decodeToken?.UsrId ||
                          decodeToken?.UsrRoleId === 1 ||
                          decodeToken?.UsrRoleId === 10 ||
                          dataActive.editable === true;

                        const statusAssignValue = dataActive?.assigned_status;
                        const toolTipsValue = statusAssignValue === "" ? "Assign to DM team" : "Temporary assign to DM team"

                        return (
                          <tr key={index}>
                            {(decodeToken?.UsrRoleId === 1 ||
                              decodeToken?.UsrRoleId === 3 ||
                              decodeToken?.UsrRoleId === 10 ||
                              decodeToken?.UsrRoleId === 11 ||
                              decodeToken?.UsrRoleId === 16) && (
                                <td>
                                  <input
                                    type="checkbox"
                                    checked={
                                      selectedRows?.includes(dataActive.id) ||
                                      false
                                    }
                                    onChange={() =>
                                      handleRowSelect(dataActive.id)
                                    }
                                  />
                                </td>
                              )}
                            <td>
                              {(currentPage - 1) * clientsPerPage + index + 1}
                            </td>
                            <td>
                              <ul className="list-inline hstack mb-0">
                                <li
                                  className="list-inline-item"
                                  data-bs-toggle="tooltip"
                                  data-bs-trigger="hover"
                                  data-bs-placement="top"
                                  aria-label="View"
                                  data-bs-original-title="View"
                                >
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-top">
                                        {canManageRow
                                          ? "Edit Detail"
                                          : "View Restricted"}
                                      </Tooltip>
                                    }
                                  >
                                    <button
                                      type="button"
                                      className="btn btn-sm btn-primary edit-item-btn"
                                      onClick={
                                        canManageRow
                                          ? () =>
                                            handleEditDetailClient(dataActive)
                                          : (e) => e.preventDefault()
                                      }
                                      disabled={!canManageRow}
                                    >
                                      <i className="ri-edit-fill align-bottom"></i>
                                    </button>
                                  </OverlayTrigger>
                                </li>
                                <li
                                  className="list-inline-item"
                                  data-bs-toggle="tooltip"
                                  data-bs-trigger="hover"
                                  data-bs-placement="top"
                                  aria-label="View"
                                  data-bs-original-title="View"
                                >
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-top">
                                        {canManageRow
                                          ? "View Detail"
                                          : "View Restricted"}
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      className={`btn btn-sm btn-info edit-item-btn`}
                                      onClick={
                                        canManageRow
                                          ? () => handleDetailClient(dataActive)
                                          : (e) => e.preventDefault()
                                      }
                                      disabled={!canManageRow}
                                    >
                                      <i className="ri-eye-fill align-bottom"></i>
                                    </Button>
                                  </OverlayTrigger>
                                </li>

                                {(decodeToken?.UsrRoleId === 1 ||
                                  decodeToken?.UsrRoleId === 3 ||
                                  decodeToken?.UsrRoleId === 10 ||
                                  decodeToken?.UsrRoleId === 11 ||
                                  decodeToken?.UsrRoleId === 16) && (
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      aria-label="View"
                                      data-bs-original-title="View"
                                    >
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={
                                          <Tooltip id="tooltip-top">
                                            {toolTipsValue}
                                          </Tooltip>
                                        }
                                      >
                                        <Button
                                          className={`btn btn-sm btn-warning edit-item-btn ${dataActive.status === 1 ||
                                            dataActive.status === 5
                                            ? ""
                                            : "disabled-btn"
                                            }`}
                                          onClick={
                                            statusAssignValue === ""
                                              ? () =>
                                                handleAssigntosaleClient(
                                                  dataActive,
                                                )
                                              : statusAssignValue === "Assigned"
                                                ? () =>
                                                  handleAssigntodmtemp(
                                                    dataActive,
                                                  )
                                                : (e) => e.preventDefault()
                                          }
                                          style={{
                                            cursor: statusAssignValue === "" || statusAssignValue === "Assigned"
                                              ? "pointer"
                                              : "not-allowed",
                                          }}
                                        >
                                          <i
                                            className={`ri-${dataActive.status !== 5
                                              ? "share"
                                              : "send-plane"
                                              }-fill align-bottom me-1 ${statusAssignValue
                                                ? ""
                                                : "restricted-icon"
                                              }`}
                                          ></i>
                                        </Button>
                                      </OverlayTrigger>
                                    </li>
                                  )}
                                {/* <li
                                className="list-inline-item"
                                data-bs-toggle="tooltip"
                                data-bs-trigger="hover"
                                data-bs-placement="top"
                              >
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-top">
                                      {decodeToken?.UsrRoleId === 3 ||
                                      decodeToken?.UsrRoleId === 5
                                        ? "Access Restricted"
                                        : dataActive.status === 1
                                          ? "Assign to DM team"
                                          : dataActive.status === 5
                                            ? "Temporary assign to DM team"
                                            : "Assign Restricted"}
                                      </Tooltip>
                                    }
                                  >
                                    <Button
                                      className={`btn btn-sm btn-warning edit-item-btn ${
                                        !(
                                          dataActive.status === 1 ||
                                          dataActive.status === 5
                                        )
                                          ? "disabled-btn"
                                          : ""
                                      }`}
                                      disabled={
                                        !(
                                          dataActive.status === 1 ||
                                          dataActive.status === 5
                                        )
                                      }
                                      onClick={
                                        dataActive.status === 1
                                          ? () =>
                                              handleAssigntosaleClient(
                                                dataActive,
                                              )
                                          : dataActive.status === 5
                                            ? () =>
                                                handleAssigntodmtemp(dataActive)
                                            : (e) => e.preventDefault()
                                      }
                                      style={{
                                        cursor: !(
                                          dataActive.status === 1 ||
                                          dataActive.status === 5
                                        )
                                          ? "not-allowed"
                                          : "pointer",
                                    }}
                                  >
                                    <i
                                      className={`ri-${
                                        dataActive.status !== 5
                                          ? "share"
                                          : "send-plane"
                                      }-fill align-bottom me-1`}
                                    ></i>
                                  </Button>
                                </OverlayTrigger>
                              </li> */}
                              </ul>
                            </td>
                            <td>{dataActive.name}</td>
                            <td>
  {formatCount(getFollowerSubscriberCount(dataActive))}
</td>
                            <td> {formatDate(dataActive.created_at)} </td>
                            <td>
                              <span
                                className={`badge w-100 ${dataActive.user_status === "Active"
                                  ? "bg-success-subtle text-success"
                                  : dataActive.user_status === "Assigned"
                                    ? "bg-info-subtle text-info"
                                    : dataActive.user_status === "Blocked"
                                      ? "bg-danger-subtle text-danger"
                                      : dataActive.user_status ===
                                      "Pending" &&
                                      "bg-warning-subtle text-warning"
                                  }`}
                              >
                                {decodeToken?.UsrRoleId === 1 ||
                                  decodeToken?.UsrRoleId === 10 ? (
                                  <OverlayTrigger
                                    placement="top"
                                    overlay={
                                      <Tooltip id="tooltip-top">
                                        {dataActive.user_status}
                                      </Tooltip>
                                    }
                                  >
                                    <button
                                      style={{ cursor: "pointer" }}
                                      onClick={
                                        decodeToken?.UsrRoleId === 1 ||
                                          decodeToken?.UsrRoleId === 10
                                          ? () => handleChangeStatus(dataActive)
                                          : null
                                      }
                                      className="btn btn-default btn-sm m-0 p-0"
                                    >
                                      {dataActive.user_status}{" "}
                                    </button>
                                  </OverlayTrigger>
                                ) : (
                                  <span className="px-1">
                                    {dataActive.user_status}
                                  </span>
                                )}
                              </span>
                            </td>
                            <td>{dataActive.email}</td>
                            <td>{dataActive.concern_person_name}</td>
                            <td>{dataActive.mobile_no}</td>
                            <td>
                              {dataActive.assigned_by_name
                                ? dataActive.assigned_by_name
                                : "-"}
                            </td>
                            <td>
                              {dataActive.assigned_to_id ===
                                decodeToken?.UsrId ? (
                                <span className="text-success p-2">You</span>
                              ) : dataActive.assigned_to_name ? (
                                dataActive.assigned_to_name
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              {JSON.parse(dataActive.language[0]).label}
                            </td>
                            {/* <td>
                              {dataActive.tmp_assigned_to_id ===
                                decodeToken?.UsrId ? (
                                <span className="text-success p-2">You</span>
                              ) : dataActive.tmp_assigned_to_name ? (
                                dataActive.tmp_assigned_to_name
                              ) : (
                                "-"
                              )}
                            </td>
                            <td>
                              {`${dataActive.to_date != "" &&
                                dataActive.to_date != null
                                ? formatDate(dataActive.to_date)
                                : "-"
                                }`}
                            </td> */}
                            <td>{dataActive.created_by_name}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="12" className="text-center">
                          No data available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
              <div className="row">
                {clientsPerPage !== 2000 && (
                  <>
                    <div className="col-sm-6">
                      Showing {start} to {end} of {totalItems} entries
                    </div>

                    <div className="col-sm-6">
                      <PaginationComponent
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddNewClients showModal={showModal} setShowModal={setShowModal} />
      <UpdateInfluencer
        showModal={showUpdateModal}
        setShowModal={setShowUpdateModal}
        selectedData={selectedData}
      />
      <AssigntoDm
        showModal={showAssignSaleModal}
        setShowModal={setAssignSaleModel}
        selectedData={selectedData}
      />
      <AssigntoDmTemp
        showModal={showAssignTempModal}
        setShowModal={setAssignTempModel}
        selectedData={selectedData}
      />
      <UpdateStatus
        showModal={showStatusModal}
        setShowModal={setStatusModel}
        selectedData={selectedData}
      />
      <Filter
        setShowFiltersDrawer={setShowFiltersDrawer}
        showFiltersDrawer={showFiltersDrawer}
        handleFilter={handleFilter}
        formData={formData}
        setFormData={setFormData}
        filterType={filterType}
        handleReset={handleReset}
      />
      <RequestForInfluencer
        setShowDetailModal={setClientRequestInf}
        showDetailModal={clientRequestInf}
        dataRowRecord={selectedData}
      />
    </>
  );
};

export default AllInfluencer;
